import { colord } from 'colord';
import { QueryParamKeys } from './constants';
import * as staticPaths from '../../staticPaths';

export interface Segment {
  label: string;
  color: string;
}

export type SpinTime = 6 | 11 | 19;

export function base64ToBytes(base64: string): Uint8Array {
  if (base64 === '') {
    return new Uint8Array();
  }
  const binString = atob(base64);
  return Uint8Array.from(binString, (m) => m.codePointAt(0) as number);
}

export function bytesToBase64(bytes: Uint8Array): string {
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte)
  ).join('');
  return btoa(binString);
}

export function encodeText(text: string): string {
  const encoder = new TextEncoder();
  const textBytes = encoder.encode(text);
  return bytesToBase64(textBytes);
}

export function decodeText(base64Str: string): string {
  const bytes = base64ToBytes(base64Str);
  const decoder = new TextDecoder();
  return decoder.decode(bytes);
}

export function getRelativeWheelShareUrl(
  text: string,
  colors?: string[]
): string {
  try {
    const params = new URLSearchParams();

    const encodedContentValue = encodeText(text);
    params.set(QueryParamKeys.content, encodedContentValue);

    if (colors) {
      const encodedColorsValue = encodeText(JSON.stringify(colors));
      params.set(QueryParamKeys.colorScheme, encodedColorsValue);
    }

    let url = `${staticPaths.wheelOfNames}?${params}`;
    return url;
  } catch (e) {
    console.error('Failed to encode state value');
    return '';
  }
}

export function isValidColor(color: string): boolean {
  const s = new Option().style;
  s.color = color;
  return s.color !== '';
}

const contrastingColorCache = new Map<string, string>();

export function getContrastingColor(color: string): string {
  if (!contrastingColorCache.has(color)) {
    const hex = colord(color).toHex().slice(1);
    const bigint = parseInt(hex.length === 3 ? hex.repeat(2) : hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    const contrastingColor = brightness > 155 ? 'black' : 'white';

    if (contrastingColorCache.size > 1000) {
      contrastingColorCache.clear();
    }
    contrastingColorCache.set(color, contrastingColor);
  }
  return contrastingColorCache.get(color) || 'black';
}

export function truncateString(str: string, maxLen: number): string {
  return str.length > maxLen ? str.slice(0, maxLen - 1) + '…' : str;
}
